module.exports = __webpack_public_path__ + "static/media/official.89356878.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/official.svg
// module id = 456
// module chunks = 0